import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const moduleDeposit = {
  namespaced: true,
  state: {
    depositBalance: null,
    recentTransactions: [],
    transactionHistory: [],
    transactionTotal: 0,
    isLoading: false
  },
  mutations: {
    setDepositBalance(state, balance) {
      state.depositBalance = balance || 0;
    },
    setRecentTransactions(state, transactions) {
      state.recentTransactions = transactions || [];
    },
    setTransactionHistory(state, transactions) {
      state.transactionHistory = transactions || [];
    },
    appendTransactionHistory(state, transactions) {
      state.transactionHistory = state.transactionHistory.concat(transactions || []);
    },
    setTransactionTotal(state, total) {
      state.transactionTotal = total || 0;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    clearDeposit(state) {
      state.depositBalance = null;
      state.recentTransactions = [];
      state.transactionHistory = [];
      state.transactionTotal = 0;
      state.isLoading = false;
    }
  },
  actions: {
    fetchDepositSummary({ commit }, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, 'fetchDepositSummary')) {
        const error = new Error('Invalid clinic/branch parameters for fetchDepositSummary');
        error.code = 'INVALID_PARAMS';
        return Promise.reject(error);
      }

      commit("setLoading", true);

      return axios
        .get(`/api/deposit/${payload.clinicUrl}/${payload.branchUrl}/patient/${payload.patientId}`)
        .then(res => {
          const data = res.data;
          commit("setDepositBalance", data.balance);
          commit("setRecentTransactions", data.recentTransactions);
          return res;
        })
        .catch(err => {
          // Reset to default values on error
          commit("setDepositBalance", null);
          commit("setRecentTransactions", []);
          throw err;
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },

    fetchTransactionHistory({ commit }, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, 'fetchTransactionHistory')) {
        const error = new Error('Invalid clinic/branch parameters for fetchTransactionHistory');
        error.code = 'INVALID_PARAMS';
        return Promise.reject(error);
      }

      const { patientId, limit = 50, offset = 0 } = payload;

      // Clear history if starting from offset 0
      if (offset === 0) {
        commit("setTransactionHistory", []);
      }

      return axios
        .get(`/api/deposit/${payload.clinicUrl}/${payload.branchUrl}/transactions/${patientId}`, {
          params: { limit, offset }
        })
        .then(res => {
          const data = res.data;
          if (offset === 0) {
            commit("setTransactionHistory", data.rows);
          } else {
            commit("appendTransactionHistory", data.rows);
          }
          commit("setTransactionTotal", data.count || 0);
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    clearDeposit({ commit }) {
      commit("clearDeposit");
    }
  },
  getters: {
    getDepositBalance: state => state.depositBalance,
    getRecentTransactions: state => state.recentTransactions,
    getTransactionHistory: state => state.transactionHistory,
    getTransactionTotal: state => state.transactionTotal,
    isLoading: state => state.isLoading
  }
};

export default moduleDeposit;
